<template>
  <section class="fixed inset-0 flex items-center justify-center z-[31] bg-black bg-opacity-30 backdrop-blur-sm mt-[70px]">
    <div id="modal modal-payment-method" class="modal absolute block bg-white dark:bg-dark-800 w-5/6 sm:w-9/12 md:w-5/12 max-w-lg shadow-md rounded-lg dark:shadow-dark-600" :class="{
      'animate__animated animate__zoomIn': showModal,
      'animate__animated animate__zoomOut': !showModal,
    }">
      <div id="modal-header" class="w-full bg-primary dark:bg-dark-600 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Metode Pembayaran' : 'Tambah Metode Pembayaran' }}</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <InputTextCustom v-model="methodName" id="method-name" label="Nama Metode"
          placeholder="Masukkan nama metode pembayaran" :valid="validation.name.valid"
          :error-message="validation.name.message" />
        <label>Masuk Cash Register</label>
        <div>
          <input type="radio" v-model="isCashRegister" :value="true" /> Ya
          <input type="radio" v-model="isCashRegister" :value="false" /> Tidak
        </div>
      </div>

      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 border border-primary bg-white dark:bg-dark-800 dark:border-dark-100 hover:bg-hover-danger hover:border-white hover:text-white text-primary dark:text-white" @click="closeModal" />
          <Button type="submit" label="Posting" :loading="loading" @click="submitPaymentMethod" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputTextCustom from '../form/InputTextCustom.vue';
import Button from 'primevue/button';
import SubmitButton from '../form/SubmitButton.vue';
import { mapActions } from 'vuex';

export default {
  name: "ModalPaymentMethod",
  props: {
    paymentMethod: {
      type: Object,
      default: null,
    }
  },
  components: {
    Button, InputTextCustom, SubmitButton
  },
  data() {
    return {
      loading: false,
      showModal: true,
      methodName: this.paymentMethod ? this.paymentMethod.name : '',
      methodCode: this.paymentMethod ? this.paymentMethod.code : '',
      isCashRegister: this.paymentMethod ? this.paymentMethod.is_cash_register : false,
      isEdit: !!this.paymentMethod,
      validation: {
        name: {
          valid: true,
          message: ''
        }
      },
      field: ['name'],
    }
  },
  watch: {
    paymentMethod(newVal) {
      if (newVal) {
        this.methodName = newVal.name;
        this.methodCode = newVal.code;
        this.isCashRegister = newVal.is_cash_register;
        this.isEdit = true;
      } else {
        this.methodName = '';
        this.methodCode = '';
        this.isCashRegister = true;
        this.isEdit = false;
      }
    }
  },
  methods: {
    ...mapActions('payment_methods', ['createPaymentMethod', 'updatePaymentMethod']),
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    submitPaymentMethod() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan metode pembayaran?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.postPaymentMethode();
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan metode pembayaran', life: 3000 });
        }
      });
    },
    async postPaymentMethode() {
      try {
        this.loading = true;
        const methodData = {
          name: this.methodName,
          code: this.methodCode,
          is_cash_register: this.isCashRegister,
        };

        if (this.isEdit && this.paymentMethod) {
          methodData.id = this.paymentMethod.id;
          await this.updatePaymentMethod(methodData);
        }
        else {
          await this.createPaymentMethod(methodData);
        }

        this.closeModal();
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Metode pembayaran berhasil disimpan', life: 5000 });
      }
      catch (error) {
        console.error('Failed to save payment method:', error);

        if (error.status === 400 && error.response.data.errors) {
          this.validationErrors(error.response.data.errors);
          this.$toast.add({ severity: 'error', summary: 'Failed', detail: error.response.data.message, life: 5000 });
        }
        else {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: error.response.data.message, life: 5000 });
        }
      }
      finally {
        this.loading = false;
      }
    },
    validationErrors(errorMessage) {
      for (let index = 0; index < this.field.length; index++) {
        this.validation[this.field[index]].valid = true;
        this.validation[this.field[index]].message = '';
      }

      errorMessage.forEach((error) => {
        if (this.validation[error.field]) {
          this.validation[error.field].valid = false;
          this.validation[error.field].message = error.message;
        }
      });
    }
  }
}
</script>